import { useState } from "react";

function RecordTab() {
  const [activeSection, setActiveSection] = useState("dashboard");
  const [selectedRecord, setSelectedRecord] = useState(null);

  // Sample record categories data
  const recordCategories = [
    {
      category: "Customer Due Diligence (CDD)",
      totalRecords: 125,
      oldestRecord: "2020-01-15",
      retentionPeriod: "5 years",
      compliance: "100%",
      status: "Compliant"
    },
    {
      category: "Suspicious Transaction Reports (STRs)",
      totalRecords: 12,
      oldestRecord: "2020-03-22",
      retentionPeriod: "5 years",
      compliance: "100%",
      status: "Compliant"
    },
    {
      category: "Transaction Records",
      totalRecords: 4523,
      oldestRecord: "2020-01-10",
      retentionPeriod: "5 years",
      compliance: "100%",
      status: "Compliant"
    },
    {
      category: "Sanctions/PEP Screening Logs",
      totalRecords: 1850,
      oldestRecord: "2020-02-01",
      retentionPeriod: "5 years",
      compliance: "100%",
      status: "Compliant"
    },
    {
      category: "Board Approvals & Reports",
      totalRecords: 48,
      oldestRecord: "2020-01-01",
      retentionPeriod: "5 years",
      compliance: "100%",
      status: "Compliant"
    }
  ];

  // Sample record retrieval log
  const retrievalLog = [
    { id: "RET-2025-001", requestedBy: "Internal Audit", category: "CDD Records", date: "2025-09-28", status: "Completed", timeToRetrieve: "4 hours" },
    { id: "RET-2025-002", requestedBy: "External Auditor", category: "STR Records", date: "2025-09-25", status: "Completed", timeToRetrieve: "6 hours" },
    { id: "RET-2025-003", requestedBy: "CBUAE Inspector", category: "Transaction Records", date: "2025-09-20", status: "Completed", timeToRetrieve: "1.5 days" }
  ];

  // Sample policy documents
  const policyDocuments = [
    { id: 1, name: "Anti-Money Laundering (AML) Policy", version: "2.0", lastUpdated: "2025-09-15", status: "Active", retainUntil: "2030-09-15" },
    { id: 2, name: "Customer Due Diligence Procedure", version: "1.5", lastUpdated: "2025-08-20", status: "Active", retainUntil: "2030-08-20" },
    { id: 3, name: "Sanctions Screening Policy", version: "1.0", lastUpdated: "2025-07-10", status: "Active", retainUntil: "2030-07-10" }
  ];

  const renderDashboard = () => (
    <div>
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>Record Keeping Dashboard</h2>
      
      {/* KPI Summary */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 20, marginBottom: 30 }}>
        <div style={{ background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#1976d2", margin: 0, fontSize: 32 }}>6,558</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>Total Records</p>
        </div>
        <div style={{ background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#4caf50", margin: 0, fontSize: 32 }}>100%</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>Retention Compliance</p>
        </div>
        <div style={{ background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#ff9800", margin: 0, fontSize: 32 }}>5</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>Record Categories</p>
        </div>
        <div style={{ background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#9c27b0", margin: 0, fontSize: 32 }}>4h</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>Avg. Retrieval Time</p>
        </div>
      </div>

      {/* Quick Actions */}
      <div style={{ display: "flex", gap: 15, marginBottom: 30 }}>
        <button
          onClick={() => setActiveSection("categories")}
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: "bold"
          }}
        >
          Record Categories
        </button>
        <button
          onClick={() => setActiveSection("retrieval")}
          style={{
            backgroundColor: "#4caf50",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: "bold"
          }}
        >
          Retrieval Log
        </button>
        <button
          onClick={() => setActiveSection("policies")}
          style={{
            backgroundColor: "#ff9800",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: "bold"
          }}
        >
          Policy Documents
        </button>
      </div>

      {/* Compliance Overview */}
      <div style={{ background: "white", padding: 30, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)", marginBottom: 30 }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Retention Policy Summary</h3>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 30 }}>
          <div>
            <h4 style={{ color: "#1976d2", marginBottom: 10 }}>Regulatory Requirements</h4>
            <ul style={{ lineHeight: 2, color: "#555" }}>
              <li>Minimum retention: <strong>5 years</strong> (UAE AML Law Art. 13)</li>
              <li>Retrieval SLA: <strong>Within 2 business days</strong></li>
              <li>Storage: Encrypted and audit-compliant database</li>
              <li>Access: Role-based with full audit trail</li>
            </ul>
          </div>
          <div>
            <h4 style={{ color: "#1976d2", marginBottom: 10 }}>Current Status</h4>
            <ul style={{ lineHeight: 2, color: "#555" }}>
              <li>Oldest record: <strong>2020-01-01</strong> (5 years retained)</li>
              <li>Average retrieval time: <strong>4 hours</strong></li>
              <li>Compliance rate: <strong>100%</strong></li>
              <li>Next purge cycle: <strong>2026-01-01</strong></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Record Categories Table */}
      <h3 style={{ color: "#0d47a1", marginBottom: 15 }}>Record Categories Overview</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", background: "white", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
        <thead>
          <tr style={{ backgroundColor: "#0d47a1", color: "white" }}>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Category</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Total Records</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Oldest Record</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Compliance</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {recordCategories.map((record, index) => (
            <tr key={index}>
              <td style={{ border: "1px solid #ccc", padding: "12px", fontWeight: "bold" }}>{record.category}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>{record.totalRecords}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>{record.oldestRecord}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>{record.compliance}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>
                <span style={{
                  backgroundColor: "#4caf50",
                  color: "white",
                  padding: "4px 12px",
                  borderRadius: "12px",
                  fontSize: "13px"
                }}>
                  {record.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderCategories = () => (
    <div>
      <button
        onClick={() => setActiveSection("dashboard")}
        style={{
          backgroundColor: "#ccc",
          color: "#333",
          border: "none",
          padding: "8px 16px",
          borderRadius: "5px",
          cursor: "pointer",
          marginBottom: 20
        }}
      >
        ← Back to Dashboard
      </button>
      
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>Record Categories Detail</h2>
      
      {recordCategories.map((record, index) => (
        <div key={index} style={{ background: "white", padding: 25, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)", marginBottom: 20 }}>
          <h3 style={{ color: "#1976d2", marginBottom: 15 }}>{record.category}</h3>
          
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 20, marginBottom: 15 }}>
            <div>
              <p style={{ color: "#666", marginBottom: 5 }}>Total Records</p>
              <p style={{ fontSize: 24, fontWeight: "bold", color: "#1976d2", margin: 0 }}>{record.totalRecords}</p>
            </div>
            <div>
              <p style={{ color: "#666", marginBottom: 5 }}>Oldest Record</p>
              <p style={{ fontSize: 18, fontWeight: "bold", color: "#333", margin: 0 }}>{record.oldestRecord}</p>
            </div>
            <div>
              <p style={{ color: "#666", marginBottom: 5 }}>Retention Period</p>
              <p style={{ fontSize: 18, fontWeight: "bold", color: "#333", margin: 0 }}>{record.retentionPeriod}</p>
            </div>
          </div>

          <div style={{ padding: 15, backgroundColor: "#e8f5e9", borderRadius: 5, marginTop: 15 }}>
            <strong>Compliance Status:</strong> All records in this category meet the 5-year retention requirement. 
            Automated purge scheduled for records older than 5 years.
          </div>
        </div>
      ))}
    </div>
  );

  const renderRetrieval = () => (
    <div>
      <button
        onClick={() => setActiveSection("dashboard")}
        style={{
          backgroundColor: "#ccc",
          color: "#333",
          border: "none",
          padding: "8px 16px",
          borderRadius: "5px",
          cursor: "pointer",
          marginBottom: 20
        }}
      >
        ← Back to Dashboard
      </button>
      
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>Record Retrieval Log</h2>
      
      <div style={{ background: "white", padding: 25, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)", marginBottom: 30 }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 15 }}>Retrieval Performance</h3>
        <p style={{ lineHeight: 1.8, color: "#555", marginBottom: 20 }}>
          As per UAE AML Law requirements, all records must be retrievable within <strong>2 business days</strong> for regulatory inspection. 
          Our current average retrieval time is <strong>4 hours</strong>, well within the required SLA.
        </p>
        
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 20 }}>
          <div style={{ padding: 15, background: "#e3f2fd", borderRadius: 5 }}>
            <p style={{ margin: 0, color: "#666" }}>Average Retrieval Time</p>
            <p style={{ fontSize: 24, fontWeight: "bold", color: "#1976d2", margin: "5px 0 0 0" }}>4 hours</p>
          </div>
          <div style={{ padding: 15, background: "#e8f5e9", borderRadius: 5 }}>
            <p style={{ margin: 0, color: "#666" }}>Total Requests (YTD)</p>
            <p style={{ fontSize: 24, fontWeight: "bold", color: "#4caf50", margin: "5px 0 0 0" }}>28</p>
          </div>
          <div style={{ padding: 15, background: "#fff3e0", borderRadius: 5 }}>
            <p style={{ margin: 0, color: "#666" }}>SLA Compliance</p>
            <p style={{ fontSize: 24, fontWeight: "bold", color: "#ff9800", margin: "5px 0 0 0" }}>100%</p>
          </div>
        </div>
      </div>

      <h3 style={{ color: "#0d47a1", marginBottom: 15 }}>Recent Retrieval Requests</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", background: "white", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
        <thead>
          <tr style={{ backgroundColor: "#0d47a1", color: "white" }}>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Request ID</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Requested By</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Category</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Date</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Time to Retrieve</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {retrievalLog.map((log) => (
            <tr key={log.id}>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>{log.id}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>{log.requestedBy}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>{log.category}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>{log.date}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>{log.timeToRetrieve}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>
                <span style={{
                  backgroundColor: "#4caf50",
                  color: "white",
                  padding: "4px 12px",
                  borderRadius: "12px",
                  fontSize: "13px"
                }}>
                  {log.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderPolicies = () => (
    <div>
      <button
        onClick={() => setActiveSection("dashboard")}
        style={{
          backgroundColor: "#ccc",
          color: "#333",
          border: "none",
          padding: "8px 16px",
          borderRadius: "5px",
          cursor: "pointer",
          marginBottom: 20
        }}
      >
        ← Back to Dashboard
      </button>
      
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>Policy Documents Archive</h2>
      
      <div style={{ background: "white", padding: 25, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)", marginBottom: 30 }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 15 }}>Version Control & History</h3>
        <p style={{ lineHeight: 1.8, color: "#555" }}>
          All policy documents are maintained with full version control. Historical versions are retained for the mandatory 5-year period. 
          Each update includes approval documentation, change logs, and Board sign-off records.
        </p>
      </div>

      <h3 style={{ color: "#0d47a1", marginBottom: 15 }}>Active Policy Documents</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", background: "white", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
        <thead>
          <tr style={{ backgroundColor: "#0d47a1", color: "white" }}>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Policy Name</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Version</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Last Updated</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Retain Until</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Status</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {policyDocuments.map((doc) => (
            <tr key={doc.id}>
              <td style={{ border: "1px solid #ccc", padding: "12px", fontWeight: "bold" }}>{doc.name}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>{doc.version}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>{doc.lastUpdated}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>{doc.retainUntil}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>
                <span style={{
                  backgroundColor: "#4caf50",
                  color: "white",
                  padding: "4px 12px",
                  borderRadius: "12px",
                  fontSize: "13px"
                }}>
                  {doc.status}
                </span>
              </td>
              <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>
                <button
                  onClick={() => setSelectedRecord(doc)}
                  style={{
                    backgroundColor: "#1976d2",
                    color: "white",
                    border: "none",
                    padding: "6px 12px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: 13,
                    marginRight: 5
                  }}
                >
                  View History
                </button>
                <button
                  onClick={() => alert("Download feature for POC demo")}
                  style={{
                    backgroundColor: "#4caf50",
                    color: "white",
                    border: "none",
                    padding: "6px 12px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: 13
                  }}
                >
                  Download
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div style={{ padding: 20 }}>
      {activeSection === "dashboard" && renderDashboard()}
      {activeSection === "categories" && renderCategories()}
      {activeSection === "retrieval" && renderRetrieval()}
      {activeSection === "policies" && renderPolicies()}

      {/* Policy History Modal */}
      {selectedRecord && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: "white",
            padding: "30px",
            borderRadius: "10px",
            width: "600px",
            maxHeight: "80vh",
            overflow: "auto"
          }}>
            <button
              onClick={() => setSelectedRecord(null)}
              style={{
                float: "right",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                padding: "8px 16px",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold"
              }}
            >
              Close
            </button>
            
            <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Version History</h3>
            <h4 style={{ color: "#333", marginBottom: 20 }}>{selectedRecord.name}</h4>
            
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ backgroundColor: "#f5f5f5" }}>
                  <th style={{ border: "1px solid #ddd", padding: "10px", textAlign: "left" }}>Version</th>
                  <th style={{ border: "1px solid #ddd", padding: "10px", textAlign: "left" }}>Date</th>
                  <th style={{ border: "1px solid #ddd", padding: "10px", textAlign: "left" }}>Approved By</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>2.0 (Current)</td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>2025-09-15</td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>Board of Directors</td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>1.5</td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>2024-06-10</td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>MLRO</td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>1.0</td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>2023-01-20</td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>Board of Directors</td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: 20, padding: 15, backgroundColor: "#e3f2fd", borderRadius: 5 }}>
              <strong>Note:</strong> All versions are retained for 5 years as per regulatory requirements. 
              Change logs and approval documentation are maintained for audit purposes.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RecordTab;